import React from "react";
import { Helmet } from "react-helmet-async";
import WorkBusiness from "../components/workBusiness/WorkBusiness";

const WorkBusinessPage = () => {
  return (
    <>
      <Helmet>
        <title>Work Business | think thing thank</title>
      </Helmet>
      <WorkBusiness />
    </>
  );
};

export default WorkBusinessPage;
